module.exports = __webpack_public_path__ + "img/baolaidian4.6f13838c.png";